import { createContext, useState } from 'react'
import { ApiService } from '../services'
import { useConfig } from '../config/ConfigProvider'

interface HttpProviderProps {
    children: React.ReactNode
}

export interface HttpProviderState {
    httpService: ApiService
}

const initialState = {
    httpService: new ApiService("", '')
}

export const HttpServiceContext = createContext<HttpProviderState>(initialState)

export default function HttpServiceProvider({ children }: HttpProviderProps) {
    console.log('🎯 HttpServiceProvider rendering...');
    const config = useConfig();
    const [state] = useState<HttpProviderState>({
        httpService: new ApiService(config.apiBaseUrl, config.microsoft_auth)
    });

    return (
        <HttpServiceContext.Provider
            value={state}
        >
            {state.httpService ? children : null}
        </HttpServiceContext.Provider>
    )
}
